<template>
  <div class="flex flex-col p-16px gap-16px items-stretch">
    <div class="text-17px font-400 text-center">
      {{ _t('package.add') }}
    </div>
    <Icon
      name="image-delete"
      class="absolute right-16px top-16px w-24px h-24px"
      @click="emit('done')"
    />
    <div class="flex flex-col gap-8px items-stretch">
      <!-- 发现卡包 -->
      <div
        class="pkg-card discover"
        @click="emit('discover'), emit('done')"
      >
        <Icon
          name="search"
          class="icon"
        />
        <div class="flex flex-col gap-4px justify-center">
          <div class="title">{{ _t('package.discover') }}</div>
          <div class="desc">{{ _t('package.search') }}</div>
        </div>
      </div>
      <!-- 创建卡包 -->
      <div
        class="pkg-card create"
        @click="emit('create'), emit('done')"
      >
        <Icon
          name="pkg-create"
          class="icon"
        />
        <div class="flex flex-col justify-center">
          <div class="title">{{ _t('package.create') }}</div>
          <div class="desc">{{ _t('package.create_tip') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Icon from '@/components/Icon.vue'

const emit = defineEmits<{
  discover: []
  create: []
  done: []
}>()
</script>

<style scoped>
.pkg-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #fff;
  box-sizing: border-box;
  transition:
    box-shadow 0.2s,
    border-color 0.2s;

  /* 禁止用户选中文字 */
  user-select: none;
  -webkit-user-select: none;
}
.pkg-card .icon {
  width: 48px;
  height: 48px;
}
.pkg-card.discover .icon {
  color: #06b6d4;
}
.pkg-card.create .icon {
  color: #8b5cf6;
}
.pkg-card .title {
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.408px;
}
.pkg-card .desc {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.24px;
}
.pkg-card.discover {
  background: #ecfeff;
  border-color: #cffafe;
}
.pkg-card.discover .title {
  color: #164e63;
}
.pkg-card.discover .desc {
  color: #0e7490;
}
.pkg-card.create {
  background: #f5f3ff;
  border-color: #ede9fe;
}
.pkg-card.create .title {
  color: #4c1d95;
}
.pkg-card.create .desc {
  color: #6d28d9;
}
</style>
